var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "css-109 ___12fm75w f1w7gpdv fez10in fg4l7m0",
    fill: "#c1c1c1",
    "aria-hidden": "true",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 1a7 7 0 0 1 6.98 6.5H3.02A7 7 0 0 1 10 3Z",
    fill: "#c1c1c1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInProgress);
export default __webpack_public_path__ + "static/media/icon-in-progress.fc1d2343c4c46abcabbc4b0b88aa5931.svg";
export { ForwardRef as ReactComponent };